var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"prompt-error"},[_c('div',{staticClass:"vue-ui-text danger banner"},[_c('VueIcon',{staticClass:"big",attrs:{"icon":"warning"}}),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.error.message)))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }